import React from "react";
import RolePermissionListForm from "./RolePermissionListForm";

const RolePermissionSection = ({
  parentMenu,
  menuList,
  roleMenuAccess,
  rolePermissions,
  onPermissionChange,
  onParentPermissionChange,
  RESTRICTED_PERMISSIONS,
  rolePermission
}) => {
  if (!parentMenu.length)
    return <p className="text-muted">No menu data available.</p>;

  return (
    <RolePermissionListForm
      parentMenu={parentMenu}
      menuList={menuList}
      roleMenuAccess={roleMenuAccess}
      rolePermissions={rolePermissions}
      onPermissionChange={onPermissionChange}
      onParentPermissionChange={onParentPermissionChange}
      RESTRICTED_PERMISSIONS={RESTRICTED_PERMISSIONS}
      rolePermission={rolePermission}
    />
  );
};

export default RolePermissionSection;
